export function resetError() {
    return {
      type: 'ERROR',
      error: null
    };
}